<!-- 查询控件 -->
<template>
  <div class="config-box">
    <el-form-item label="箭头位置 " label-width="80">
      <div class="flex vcenter" style="position: relative; top: 5px">
        <el-tooltip
          effect="dark"
          content="指标卡箭头与指标值的位置"
          placement="top-start"
        >
          <el-icon class="mr-6 mb-10" style="position: relative; right: 8px">
            <QuestionFilled color="#ffffff" />
          </el-icon>
        </el-tooltip>
        <el-radio-group v-model="modelValue.arrowPosition" size="small">
          <el-radio label="left">左</el-radio>
          <el-radio label="right">右</el-radio>
        </el-radio-group>
      </div>
    </el-form-item>
    <el-form-item label="上箭头" label-width="80">
      <el-tooltip
        effect="dark"
        content="只可上传svg图标，改色会修改svg的fill与stroke颜色"
        placement="top-start"
      >
        <el-icon
          class="mr-6 mb-10"
          style="position: absolute; left: -8px; top: 8px"
        >
          <QuestionFilled color="#ffffff" />
        </el-icon>
      </el-tooltip>
      <span class="ml-14" v-html="upSvgStr"></span>
      <div class="flex ml-14">
        <el-input clearable v-model="modelValue.upImage" size="small">
        </el-input>
        <UploadImg
          accept=".svg"
          class="ml-4"
          v-model="modelValue.upImage"
        ></UploadImg>
        <div class="ml-4">
          <el-color-picker
            :predefine="predefineColors"
            show-alpha
            v-model="modelValue.upColor"
          ></el-color-picker>
        </div>
      </div>
    </el-form-item>
    <el-form-item label="下箭头" label-width="80">
      <span v-html="downSvgStr"></span>
      <div class="flex">
        <el-input clearable v-model="modelValue.downImage" size="small">
        </el-input>
        <UploadImg
          accept=".svg"
          class="ml-4"
          v-model="modelValue.downImage"
        ></UploadImg>
        <div class="ml-4">
          <el-color-picker
            :predefine="predefineColors"
            show-alpha
            v-model="modelValue.downColor"
          ></el-color-picker>
        </div>
      </div>
    </el-form-item>
  </div>
</template>

<script>
import UploadImg from "./upload.vue";
import { DRILL_TYPE, predefineColors } from "@/option/common/dict";
import { getSVGWithColor } from "@/utils/utils";
import { QuestionFilled } from "@element-plus/icons-vue";

export default {
  name: "iconConfig",
  computed: {
    DRILL_TYPE() {
      return DRILL_TYPE;
    },
  },
  data() {
    return {
      predefineColors,
      upSvgStr: "",
      downSvgStr: "",
    };
  },
  props: {
    modelValue: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    "modelValue.downImage": {
      handler() {
        this.getDown();
      },
    },
    "modelValue.upImage": {
      handler() {
        this.getUp();
      },
    },
    "modelValue.downColor": {
      handler() {
        this.getDown();
      },
    },
    "modelValue.upColor": {
      handler() {
        this.getUp();
      },
    },
  },
  components: {
    QuestionFilled,
    UploadImg,
  },
  mounted() {
    this.getUp();
    this.getDown();
  },
  methods: {
    getUp() {
      if (!this.modelValue.upImage) return;
      getSVGWithColor(this.modelValue.upImage, this.modelValue.upColor).then(
        (el) => {
          this.upSvgStr = el;
        }
      );
    },
    getDown() {
      if (!this.modelValue.downImage) return;
      getSVGWithColor(
        this.modelValue.downImage,
        this.modelValue.downColor
      ).then((el) => {
        this.downSvgStr = el;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.config-box {
  padding: 5px 0;
}
</style>
